<template>
  <div class="product-display-display" ref="product_display_display">
    <div class="product-display-display-header">
      <div class="button-containt">
        <template
          v-if="
            !productDetailsInfos.is_draft &&
            (($store.getters.customer != undefined &&
              productDetailsInfos.sellerId != $store.getters.customer.id) ||
              $store.getters.customer == undefined)
          "
        >
          <template v-if="$store.getters.productDetailsInfos.availibilityId != 2">
            <!-- <div playwright-id="add-to-cart-button">
              <TButton
                v-if="$store.getters.productDetailsInfos.availibilityId != 1"
                :color="'primary-color'"
                buttonClass="header-button"
                :icon-position="'center'"
                :label="$translation($websiteText().product_details_add_to_cart)"
                @click="cartClick($store.getters.kitId)"
              ></TButton>
            </div> -->

            <div>
              <TButton
                v-if="$store.getters.productDetailsInfos.availibilityId != 1 && $store.getters.productDetailsInfos.is_negotiable"
                buttonClass="header-button"
                :color="'secondary-color'"
                :label="$translation($websiteText().how_it_works_request_second_point_title)"
                @click="goToChat"
              ></TButton>
            </div>

            <TButton
              v-if="$store.getters.productDetailsInfos.availibilityId == 1"
              :onClick="openRfpPopup"
              color="primary-color"
              :label="$translation($websiteText().product_details_request_similar_item)"
              buttonClass="header-button"
            />

            <TButton
              v-if="$store.getters.productDetailsInfos.availibilityId == 1"
              :onClick="goToShop"
              color="secondary-color"
              :label="$translation($websiteText().product_details_show_similar_items)"
              buttonClass="header-button"
            />
      
            <div class="favorites-btn-div">
              <TButton
                v-if="$store.getters.productDetailsInfos.availibilityId != 1"
                :buttonClass="{'icon-button': true}"
                :color="'#ffff'"
                :image="$config.favoriteIconProduct"
                :imageStyle="'height:30px; width:30px; background:#F7F7F7;'"
                :rounded="true"
                @click.stop.prevent="watchListClick($store.getters.kitId)"
              ></TButton>
            </div>
          </template>
        </template>
        <div class="share-btn-div">
          <TButton
            :buttonClass="{'icon-button': true}"
            :color="'#ffff'"
            :rounded="true"
            :imageStyle="'height:30px; width:30px; background:#F7F7F7;'"
            :image="$config.shareIconProduct"
            @click.stop.prevent="shareClick()"
          ></TButton>
        </div>
      </div>
    </div>

    <div class="product-display-mobile-header">
      <div class="colonne1-header">
        <i @click="closeProductDetailsPopup" class="pi pi-times"></i>
        <img class="logo-mobile" :src="$config.mobileSmallLogo" />
      </div>
      <div class="colonne2-header">
        <div class="relativ-position row1">
          <TButton
            v-if="$store.getters.productDetailsInfos.availibilityId != 1"
            onClick="Home"
            :textual="true"
            label=""
            color="light"
            icon="pi pi-bell"
            iconPosition="right"
          />
          <Badge
            class="small-badge-specs bell-absolute-position"
            v-show="notifications > 0"
          ></Badge>
        </div>
        <div class="relativ-position row1">
          <TButton
            v-if="$store.getters.productDetailsInfos.availibilityId != 1"
            onClick="inbox"
            :textual="true"
            color="light"
            label=""
            icon="pi pi-inbox"
            iconPosition="right"
          />
          <Badge
            class="small-badge-specs inbox-absolute-position"
            v-show="messages > 0"
          ></Badge>
        </div>
        <div class="relativ-position row1">
          <TButton
            v-if="$store.getters.productDetailsInfos.availibilityId != 1"
            onClick="cart"
            :textual="true"
            color="light"
            label=""
            icon="pi pi-shopping-cart"
            iconPosition="right"
          />
          <Badge
            class="small-badge-specs cart-absolute-position"
            v-show="items > 0"
          ></Badge>
        </div>
      </div>
    </div>

    <div class="product-display-mobile-footer">
      <div class="colonne2-footer">
        <template
          v-if="
            !productDetailsInfos.is_draft &&
            (($store.getters.customer != undefined &&
              productDetailsInfos.sellerId != $store.getters.customer.id) ||
              $store.getters.customer == undefined)
          "
        >
          <!-- <TButton
            v-if="$store.getters.productDetailsInfos.availibilityId != 1"
            buttonClass="add-to-cart-button"
            :icon="'pi pi-shopping-cart'"
            :label="$translation($websiteText().product_details_add_to_cart)"
            @click="cartClick($store.getters.kitId)"
          ></TButton> -->
        </template>
      </div>

      <div class="colonne1-footer">
        <TButton
          v-if="$store.getters.productDetailsInfos.availibilityId == 1"
          :onClick="openRfpPopup"
          color="primary-color"
          :label="$translation($websiteText().header_request_button)"
        />

        <TButton
          @click.stop.prevent="shareClick()"
          buttonClass="watchlist"
          :color="'light'"
          :icon="'pi pi-share-alt'"
          :rounded="true"
        ></TButton>

        <template
          v-if="
            !productDetailsInfos.is_draft &&
            (($store.getters.customer != undefined &&
              productDetailsInfos.sellerId != $store.getters.customer.id) ||
              $store.getters.customer == undefined)
          "
        >
          <template v-if="$store.getters.productDetailsInfos.availibilityId != 2">
            <TButton
              v-if="$store.getters.productDetailsInfos.availibilityId != 1"
              @click="watchListClick($store.getters.kitId)"
              buttonClass="watchlist"
              :color="'light'"
              :icon="'pi pi-bookmark'"
              :label="$translation($websiteText().sell_save_draft_button)"
              :rounded="true"
            ></TButton>
            <TButton
              v-if="$store.getters.productDetailsInfos.availibilityId != 1"
              @click="goToChat"
              buttonClass="question"
              :color="'secondary'"
              :icon="'pi pi-comment'"
              :label="$translation($websiteText().sell_save_draft_button)"
              :rounded="true"
            ></TButton>
         
          </template>
        </template>
      </div>
    </div>

    <ContentProduct />
  </div>
</template>

<script>
import TButton from "../../../common/components/buttons/TButton.vue";
import store from "../../../store";
import {defineAsyncComponent} from "vue";
const ContentProduct = defineAsyncComponent(() => import("./ProductDetailsContaint.vue"));
const Chat = defineAsyncComponent(() =>
  import(
    "../../product-details/components/productComunication/HeaderProductComunicationDesktop"
  )
);

import {CREATE_WATCHLIST_RECORD, DELETE_WATCHLIST_RECORD} from "../store/actions";
import {ADD_KIT_TO_CART} from "../../checkout/store/actions";
import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import { TOGGLE_AUTH_POPUP } from "../../authentication/store/actions";




export default {
  components: {
    TButton,
    ContentProduct,
  },
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    productDetailsInfos() {
      return this.$store.getters.productDetailsInfos;
    },
  },
  mounted() {},
  created() {},
  setup() {
    const cartClick = (kit) => {
      store.dispatch(ADD_KIT_TO_CART, kit);
    };

    let showShareIt = false;
    const checkWatchlistActive = (kit) => {
      return store.getters.watchlistList[kit] != undefined ? true : false;
    };
    const watchListClick = (kit) => {
      if (!checkWatchlistActive(kit)) store.dispatch(CREATE_WATCHLIST_RECORD, kit);
      else store.dispatch(DELETE_WATCHLIST_RECORD, kit);
    };

    const shareClick = () => {
      var currentPageUrl = window.location.href
      if (store.getters.isAuthenticated && store.getters.customer.is_affiliate)
      {
        let url = new URL(currentPageUrl);
        url.searchParams.append('ref',store.getters.customer.affiliate_id)
        currentPageUrl = url.toString();
      }

      var tempInput = document.createElement('input');
      tempInput.value = currentPageUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      store.dispatch(
        SHOW_TOAST_MESSAGE,
        GeneralHelper.buildMessage(1, 'link copied!')
      )

      tempInput.remove()

    };

    return {
      watchListClick,
      checkWatchlistActive,
      cartClick,
      showShareIt,
      shareClick,
    };
  },
  methods: {
    closeProductDetailsPopup() {
      this.$store.commit("displayProductDetails1", {option: false});
    },
    goToRfpPage() {
      //this.store.dispatch(OPEN_RFP_DIALOG);
      if (this.$store.getters.isAuthenticated == false)
        this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
      this.$router.push({name: "postRequest"});
    },
    goToShop()
    {
      this.$router.push({name: "Shop",query: { categories: '['+this.productDetailsInfos.categoryId+']', maxPrice:this.productDetailsInfos.price }})
    },
    openRfpPopup() {
      let kit = this.$store.getters.productItemsDetails;
      let items = kit;
      let main_item;

      for (let i = 0; i < items.length; i++) {
        if (items[i].is_main == 1) {
          main_item = items[i];
          break;
        }
      }

      let product = main_item.product;

      this.$store.commit("SET_SOLD_RFP_DETAILS", {
        brands: [product.brand_id],
        products: [{name: product.name, id: product.id, value: product.id}],
        categories: [
          {
            name: product.category.name,
            id: product.category_id,
            value: product.category_id,
          },
        ],
        conditions: [1],
        title: this.$store.getters.productDetailsInfos.title,
        description: this.$store.getters.description,
        currency: this.$store.getters.productDetailsInfos.kitCurrencyId,
        budget: [0, this.$store.getters.productDetailsInfos.price],
      });
      
      this.goToRfpPage();
    },
    select(item) {
      this.selected = item;
    },
    goToChat() {
      this.$store.dispatch("productActiveComponent", "DialogSection");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/ProductDetailsContaint.scss";

::v-deep
  .product-display-display
  .product-display-display-header
  .button-containt
  .share-btn-div {
  .icon-button {
    border: none !important;
  }
}

::v-deep
  .product-display-display
  .product-display-display-header
  .button-containt
  .favorites-btn-div {
  .icon-button {
    border: none !important;
  }
}
</style>
